<template>
  <div class="is-border vadTask has-background-white">
    <div class="vadTask-hover"></div>
    <div class="is-padding-left is-padding-right is-padding-top-small is-padding-bottom-small">
      <div class="columns">
        <div class="column is-narrow">
          <avatar
            :use-picto-custom="'fas fa-signature'"
            :force-picto="true"
            :is-avatar="false"
            :item="{}"
            class="has-background-pending is-medium has-text-white is-margin-top-xsmall">
          </avatar>
        </div>
        <div class="column">
          <p class="is-size-7 has-text-weight-light has-text-grey is-margin-bottom-xxsmall">
            <span v-if="isToday">Aujourd’hui à {{ reservation.updated_on | dtFormat('HH[h]mm') }}</span>
            <span v-else>{{ reservation.updated_on | prettyDatetime }}</span>
          </p>
          <p class="is-size-4 is-margin-bottom-xsmall">
            <strong>Demande de réservation
              <router-link :to="{name: 'ProgramVue', params: {id: reservation.program.pk}}">
                <!-- — {{reservation.program.name}} - {{reservation.lot.ref}} -->
              </router-link>
            </strong>
          </p>
          <div class="columns is-multiline is-gapless">
            <div class="column is-6">
              <router-link
                :to="{name: 'ProgramVue', params: {id: reservation.program.pk}}"
                class="is-size-6">
                <span class="has-text-grey">Programme</span><br><span
                  class="is-hover-underline">{{ reservation.program.name }}</span>
              </router-link>
            </div>
            <div
              v-if="reservation.account && reservation.account.pk !== currentUser.account.pk "
              class="column is-6">
              <router-link
                :to="{name: 'LotVue', params: {id: reservation.lot.pk}}"
                class="is-size-6">
                <span class="has-text-grey">Lot</span><br><span
                  class="is-hover-underline">{{ reservation.lot.ref }}</span>
              </router-link>
            </div>
            <div class="column is-6 is-margin-top-xxsmall">
              <span class="has-text-grey is-size-6">Vendeur : </span>
              <router-link
                :to="{name: 'UserVue', params: {id: reservation.user.pk}}"
                class="is-size-6">
                <span
                  class="is-hover-underline">{{ reservation.user.first_name }} {{ reservation.user.last_name }}</span>
              </router-link>
            </div>
            <div class="column is-6 is-margin-top-xxsmall">
              <span class="has-text-grey is-size-6">Acquéreur :</span>&nbsp;
              <router-link
                v-if="reservation.account.pk === currentUser.account.pk"
                :to="{name: 'ContactVue', params: {id: reservation.contact.pk}}"
                class="is-size-6">
                <span
                  class="is-hover-underline">{{ reservation.contact.first_name }} {{ reservation.contact.last_name }}</span>
              </router-link>
              <span
                v-else
                class="is-size-6">
                <span>{{ reservation.contact.first_name }} {{ reservation.contact.last_name }}</span>
              </span>
            </div>
            <div
              v-if="reservation.account && reservation.account.pk !== currentUser.account.pk "
              class="column is-6">
              <span class="has-text-grey is-size-6">Société : </span>
              <router-link
                :to="{name: 'CompanyVue', params: {id: reservation.account.pk}}"
                class="is-size-6">
                <span class="is-hover-underline">{{ reservation.account.name }}</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
      mode="out-in">
      <div
        v-if="isPending"
        key="buttons"
        class="veryFastAnimation is-paddingless-top is-paddingless-bottom is-border-top is-border--dashed vadTask-footer">
        <router-link
          :to="{name: 'PreReservation', params: { id: reservation.pk }}"
          class="button is-white is-small is-size-7">
          <span class="icon is-small"><i class="fas fa-align-left"></i></span>
          <span>Consulter formulaire de demande</span>
        </router-link>
      </div>
      <div
        v-else-if="!isPending && reservation.updated_on"
        key="noButtons"
        class="veryFastAnimation is-padding-top-xsmall is-padding-bottom-xsmall is-border-top vadTask-footer has-background-light--darken--1 is-border-top is-border--dashed">
        <div class="has-text-grey is-size-6">
          Validation <span v-if="isApproved">acceptée</span><span v-else>refusée</span>
          le {{ reservation.updated_on | prettyDatetime }}
          <span v-if="reservation.update_author === currentUserPk">
            par vous.
          </span>
          <span v-else-if="reservation.update_author_name">
            par {{ reservation.update_author_name }}
          </span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex/dist/vuex.esm.browser'
import { mapState } from 'vuex'

export default {
  name: 'ReservationCard',
  props: {
    reservation: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      cardLoading: false
    }
  },
  computed: {
    ...mapState(['currentUser']),
    ...mapGetters(['currentUserPk']),
    /**
     * return moment() update date
     * @return {string}
     */
    date () {
      return moment(this.reservation.updated_on)
    },
    /**
     * is today
     * @return {boolean}
     */
    isToday () {
      return this.date.isSame(moment(), 'day')
    },
    /**
     * pk of reservation
     * @return {string}
     */
    reservationPk () {
      return this.reservation.pk
    },
    /**
     * reservation status
     * @return {string}
     */
    status () {
      return this.reservation.status
    },
    /**
     * is status pre_reserved
     * @return {boolean}
     */
    isPreReserved () {
      return this.status === 'pre_reserved'
    },
    /**
     * is status refused
     * @return {boolean}
     */
    isRefused () {
      return this.status === 'refused'
    },
    /**
     * status is approved
     * @return {boolean}
     */
    isApproved () {
      return this.status === 'approved'
    },
    /**
     * is status pending
     * @return {boolean}
     */
    isPending () {
      return this.status === 'pending'
    }
  }
}
</script>

<style scoped>

</style>
